module.exports = __webpack_public_path__ + "img/blue_013.0b0399f4.png";